import './style.scss';
import ItemsPanel from './ItemsPanel';
import MediaObject from './MediaObject';
import React from 'react';
import { inject, observer } from 'mobx-react';
import { injectIntl } from 'react-intl';
import { LinkContainer } from 'react-router-bootstrap';
import { Row, Col, Tab, NavItem, Nav } from 'react-bootstrap';
import { inactiveMembersKey } from './constants';

@injectIntl
@inject('membersStore', 'rootStore')
@observer
export default class ItemsMenu extends React.Component {
  render() {
    let { membersStore, items } = this.props;
    let roles = membersStore.features[items];
    return (
      <Tab.Container
        className="bhoechie-tab-container"
        defaultActiveKey={
          this.props.items === 'mRoles' ? 'ceo' : 'board_of_director'
        }
        id={this.props.items}
      >
        <Row className="clearfix">
          <Col xs={12} md={2} className="bhoechie-tab-menu">
            <Nav
              id="roles-stack"
              bsStyle="pills"
              stacked
              className="list-group nav-tabs"
            >
              {[...roles, inactiveMembersKey].map((e, idx) => {
                return e === 'none' ? null : (
                  <NavItem key={idx} eventKey={e}>
                    {this.props.intl.formatMessage({ id: e + 's' })}
                  </NavItem>
                );
              })}
            </Nav>
          </Col>
          <Col className="bhoechie-tab" xs={12} md={10}>
            <Tab.Content animation>
              {[...roles, inactiveMembersKey].map((e, idx) => (
                <Tab.Pane key={idx} eventKey={e}>
                  <ItemsPanel key={idx} e={e} items={items} />
                </Tab.Pane>
              ))}
            </Tab.Content>
          </Col>
        </Row>
      </Tab.Container>
    );
  }
}
